module.exports = "\r\n#rm-report-div {\r\n  min-height: 85vh;\r\n}\r\n\r\n.project-name {\r\n  cursor: pointer;\r\n}\r\n\r\n.project-name:hover {\r\n  color: #522f91;\r\n  font-weight: 600;\r\n}\r\n\r\n.project-highlight {\r\n  width: 60%;\r\n}\r\n\r\n#rm-report-div .report-table {\r\n    background: #fff;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/rm/my-report/my-report.component.css
// module id = ./src/app/rm/my-report/my-report.component.css
// module chunks = main